import { PlayfulThemeId } from '../identifiers';
import { PlayfulThemeDefinition } from '../types';
import { IconName } from '@/icons/types';
import { MagicMascot } from '@/components/core/ThemeMascot/mascots';

export const magicTheme: PlayfulThemeDefinition = {
  id: PlayfulThemeId.MAGIC,
  hover: {
    transform: 'translateY(-5px) scale(1.03)',
    transition: 'transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
  },
  click: {
    transform: 'scale(0.93) rotate(-2deg)',
    transition: 'transform 0.15s ease-out',
  },
  idle: {
    animationName: 'playful-magic-shimmer',
    animationDuration: '3s',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite',
  },
  dragStart: {
    transform: 'scale(1.06) rotate(3deg)',
    transition: 'transform 0.2s ease-out',
  },
  particles: {
    enabled: true,
    count: 12,
    characters: ['✨', '🪄', '⭐', '💜'],
    spread: 70,
    duration: 1500,
    size: 14,
  },
  keyframes: [
    {
      name: 'playful-magic-shimmer',
      css: `@keyframes playful-magic-shimmer {
  0%, 100% { transform: translateY(0) scale(1); opacity: 1; }
  50% { transform: translateY(-2px) scale(1.01); opacity: 0.95; }
}`,
    },
  ],
  sounds: {
    hover: { name: 'ui/success_chime', volume: 0.12, rate: 1.5 },
    click: { name: 'arcade/coin_bling', volume: 0.25 },
  },
  metadata: {
    label: 'Magic',
    icon: IconName.SPARKLES,
    previewEmoji: '🪄',
    description: 'Sparkly enchantment',
    mascotEmoji: '🪄',
    mascotComponent: MagicMascot,
  },
};
